// Left rail: lists every agent registered in the agents service. Selecting an
// agent flips the active agent and shows that agent's threads in the
// sub-sidebar to the right.

const initials = (label = "") => label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("") || "AG";

const sortAgents = (agents) =>
    [...(agents || [])].sort((a, b) =>
        (a.label || a.id || "").localeCompare(b.label || b.id || "", undefined, { sensitivity: "base" })
    );

const AgentSelector = ({ agents, selectedAgentId, onSelect, isLoading, error }) => {
    const sorted = sortAgents(agents);
    return (
        <aside className="agents-rail">
            <div className="agents-rail__header">Agents</div>

            <div className="agents-rail__list scrollable-form">
                {isLoading && <div className="loader" style={{ margin: "1rem auto" }} />}
                {error && <p className="danger" style={{ padding: "0 .8rem" }}>{error}</p>}

                {sorted.map((agent) => (
                    <div
                        key={agent.id}
                        className={`agent-item ${selectedAgentId === agent.id ? "is-active" : ""}`}
                        onClick={() => onSelect(agent.id)}
                        title={agent.description}
                    >
                        <div className="agent-item__icon">{initials(agent.label)}</div>
                        <div className="agent-item__body">
                            <div className="agent-item__label">{agent.label}</div>
                            <div className="agent-item__description">{agent.description}</div>
                        </div>
                    </div>
                ))}

                {!isLoading && !sorted.length && (
                    <div style={{ padding: ".8rem", color: "var(--grey)", fontSize: ".85rem" }}>
                        No agents available
                    </div>
                )}
            </div>
        </aside>
    );
};

export default AgentSelector;
